import { useState } from "react"
import { useHistory } from "react-router"

// providers
import { useAuthDataContext } from "@/_providers/Auth"

// images
import downArrowImage from "@/assets/img/header/icons/down-arrow.svg"

// libraries
import { Button } from "@mui/material"
import ClickAwayListener from "react-click-away-listener"

// providers
import { trans } from "@/_providers/Translation"

export default function UserInHeader() {
  const auth = useAuthDataContext()
  const history = useHistory()

  const [visible, setVisible] = useState(false)

  return (
    <ClickAwayListener onClickAway={() => setVisible(false)}>
      <>
        <Button
          onClick={() => {
            setVisible(true)
          }}
        >
          <img src={auth?.data?.user?.avatar} alt="" />
          <span>
            {auth?.data?.user?.name} {auth?.data?.user?.lastname}
            <img src={downArrowImage} alt="" />
          </span>
        </Button>
        {visible ? (
          <div className={`show messages-module`}>
            <div className="head">{trans("labels.profile")}</div>
            <div className="body">
              <ul
                onClick={() => {
                  setVisible(false)
                }}
              >
                <li
                  onClick={() => {
                    history.push("/profile/settings")
                  }}
                >
                  Настройки
                </li>
                <li onClick={auth.logout}>{trans("buttons.exit")}</li>
              </ul>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    </ClickAwayListener>
  )
}
